import {combineReducers, createStore} from 'redux'

import {entertaimentReducer, languagePackReducer, projectsReducer} from '../reduces/default'

export default () => {
    const store = createStore(
        combineReducers({
            languagePack: languagePackReducer,
            entertaiment: entertaimentReducer,
            data: projectsReducer,
        })
    )

    return store;
}


// WEBPACK FOOTER //
// ./src/config/store.js